import store from '@/store'

export function qcopy(obj) {
  return !obj ? obj : JSON.parse(JSON.stringify(obj))
}

export function deepClone(obj) {
  if (obj === null || typeof obj !== 'object') {
    return obj
  }

  const newObj = Array.isArray(obj) ? [] : {}

  for (const key in obj) {
    newObj[key] = deepClone(obj[key])
  }

  return newObj
}

export function isHighGlu(glu) {
  const limit = store.state.redraw.cmax
  // console.error(`[isHighGlu], 入参 glu: ${glu}, cmax: ${limit}, cmin: ${store.state.redraw.cmin}`)
  
  if (Number.isNaN(+glu)) {
    try {
      console.error(`[isHighGlu]cmax: ${limit}, 入参glu有误，不是合法数字: ${JSON.stringify(glu)}`, glu)    
    } catch (error) {
      console.error('被捕获:' + error)
    }
  }
  
  return glu - limit > 0
}

export function isLowGlu(glu) {
  const limit = store.state.redraw.cmin
  // console.error(`[isLowGlu], 入参 glu: ${glu}, cmin: ${limit}, cmax: ${store.state.redraw.cmin}`)

  if (Number.isNaN(+glu)) {
    try {
      console.error(`[isLowGlu]cmin: ${limit}, 入参glu有误，不是合法数字: ${JSON.stringify(glu)}`, glu)    
    } catch (error) {
      console.error('被捕获:' + error)
    }
  }
  
  return glu - limit < 0
}

export function isNormalGlu(glu) {
  return !isHighGlu(glu) && !isLowGlu(glu)
}

export function findObjIndexInArray(array = [], objOrKeyVal, objKey = 'id') {
  const compareFunc = (typeof objKey === 'string') ? function (objInArray = {}, obj2 = {}) {
    return `${objInArray[objKey]}` === `${obj2[objKey]}`
  } : objKey // 简单粗暴，就默认objKey是个函数

  let obj
  if (['number', 'string'].includes((typeof objOrKeyVal))) {
    if (typeof objKey !== 'string') {
      // 简单粗暴，认为是函数
      console.error(`findObjIndexInArray用法不对`)
    }
    obj = {}
    obj[objKey] = objOrKeyVal // 简单粗暴
  } else {
    obj = objOrKeyVal
  }

  let rst = -1

  if (typeof array.map !== 'function') {
    console.error(`findObjIndexInArray, array传参不是合法数组, typeof array: ${typeof array}`)
    return -1
  }
  array.map((v, i) => {
    if (compareFunc(v, obj)) rst = i
  })
  return rst
}
export function padZero(str, targetL = 2) {
  str = `${str}`
  if (str === '') return (Array.from({ length: targetL }).map(v => 0)).join('')
  const l = str.length

  if (l - targetL >= 0) {
    return str
  }

  const gap = targetL - l
  return (Array.from({ length: gap }).map(v => 0)).join('') + str
}
export function trimEndZero(str) {
  if (Number.isNaN(+str)) return str
  const s = `${str}`.trim()
  let rst = s

  if (/(.+)\.0+$/.test(s)) {
    // 1.00
    rst = RegExp.$1
  } else if (/((.+)\.[0-9]*[1-9]+)0+$/.test(s)) {
    // 1.00100
    rst = RegExp.$1
  }

  return rst  
}
